import { parseServerUtcToLocalDate } from '../date/serverUtcToLocal';

export function formatUnixSeconds(
  tsSeconds: number | undefined | null,
  fmt: string = 'yyyy/MM/dd HH:mm'
): string {
  if (tsSeconds === undefined || tsSeconds === null) return 'n/a';
  const d = parseServerUtcToLocalDate(tsSeconds, 'seconds');
  if (!d) return 'n/a';
  const map: Record<string, string> = {
    yyyy: String(d.getFullYear()),
    MM: String(d.getMonth() + 1).padStart(2, '0'),
    dd: String(d.getDate()).padStart(2, '0'),
    HH: String(d.getHours()).padStart(2, '0'),
    mm: String(d.getMinutes()).padStart(2, '0'),
  };
  return fmt.replace(/yyyy|MM|dd|HH|mm/g, (token) => map[token]);
}
